import { React, useCallback, useEffect, useMemo, useState } from "react";
import "./popup.scss";
import { AiOutlineClose } from "react-icons/ai";
import {
  PopupMoveAtWork,
  PopupGroepsaankoop,
  PopupInspiratie,
  PopupTopsportScholen,
  PopupPublicatie,
  PopupGeneriek,
  PopupMentalMatrix,
  PopupWebinar,
  PopupInnovatieportfolio,
  PopupWetenschappelijkOnderzoek,
  PopupToolkit,
} from "./PopupTypes";
import { Image } from "../Image/Image";

export const Popup = (props) => {
  const [detailImage, setDetailImage] = useState(null);
  const [ficheTypeClassName, setFicheTypeClassName] = useState(null);
  const [ficheTypeIconClass, setFicheTypeIconClass] = useState(null);

  const processSidebarContentBlockList = useCallback((blockListContent) => {
    let contentBlocks = [];
    blockListContent.forEach((contentItem, i) => {
      contentBlocks.push(
        <p key={i}>
          <strong>{contentItem.title}</strong>
          <br />
          {contentItem.text}
        </p>
      );
    });
    return contentBlocks;
  }, []);

  const processContentBlockList = (blockListContent) => {
    let contentBlocks = [];
    blockListContent.forEach((contentItem, bodyIndex) => {
      let urls = [];
      contentItem.links.forEach((link, urlIndex) => {
        urls.push(
          <div key={"url_" + urlIndex}>
            <a href={link.Url} className={"c-button"} target={link.Target}>
              {link.Name}
            </a>
          </div>
        );
      });
      contentBlocks.push(
        <div
          key={"contentItem_" + bodyIndex}
          className="c-content-block text-block"
        >
          <h3>{contentItem.title}</h3>
          <div dangerouslySetInnerHTML={{ __html: contentItem.text }}></div>
          <div>{urls}</div>
        </div>
      );
    });
    return contentBlocks;
  };

  const content = useMemo(() => {
    switch (props.type) {
      //Move at work
      case "ficheMoveAtWork":
        setFicheTypeClassName("c-moveAtWork");
        return (
          <PopupMoveAtWork
            printComponentToPdf={props.printComponentToPdf}
            dictionary={props.dictionary}
            data={props.data}
            blockListBodyContentHandler={processContentBlockList}
          />
        );
      //Groepsaankoop
      case "ficheGroepsaankoop":
        setFicheTypeClassName("c-groepsaankopen");
        setFicheTypeIconClass("themeicon");
        return (
          <PopupGroepsaankoop
            dictionary={props.dictionary}
            data={props.data}
            blockListBodyContentHandler={processContentBlockList}
          />
        );
      case "ficheInspiratie":
        setFicheTypeClassName("c-inspiration");
        setFicheTypeIconClass("corona");
        return (
          <PopupInspiratie
            printComponentToPdf={props.printComponentToPdf}
            dictionary={props.dictionary}
            data={props.data}
            blockListBodyContentHandler={processContentBlockList}
            blockListSideBarContentHandler={processSidebarContentBlockList}
          />
        );
      case "ficheTopsportschool":
        setFicheTypeClassName("c-topsportschool");
        return (
          <PopupTopsportScholen
            dictionary={props.dictionary}
            data={props.data}
            blockListBodyContentHandler={processContentBlockList}
          />
        );
      case "fichePublicatie":
        setFicheTypeClassName("c-publications");
        props.data.detailImage &&
          setDetailImage(
            <Image
              src={props.data.detailImage.url}
              alt={props.data.detailImage.alt}
            />
          );
        return (
          <PopupPublicatie
            dictionary={props.dictionary}
            data={props.data}
            closePopupHandler={props.closePopupHandler}
          />
        );
      case "ficheGeneriek":
      case "dynamicFiche":
        setFicheTypeClassName("c-generic");
        props.data.detailImage &&
          setDetailImage(
            <Image
              src={props.data.detailImage.url}
              alt={props.data.detailImage.alt}
            />
          );
        return (
          <PopupGeneriek
            dictionary={props.dictionary}
            data={props.data}
            blockListBodyContentHandler={processContentBlockList}
          />
        );
      case "ficheMentalMatrix":
        setFicheTypeClassName("c-mentalMatrix");
        props.data.detailImage &&
          setDetailImage(
            <Image
              src={props.data.detailImage.url}
              alt={props.data.detailImage.alt}
            />
          );
        return (
          <PopupMentalMatrix
            dictionary={props.dictionary}
            data={props.data}
            blockListBodyContentHandler={processContentBlockList}
          />
        );
      case "ficheWebinar":
        setFicheTypeClassName("c-webinar");
        props.data.detailImage &&
          setDetailImage(
            <Image
              src={props.data.detailImage.url}
              alt={props.data.detailImage.alt}
            />
          );

        return (
          <PopupWebinar
            dictionary={props.dictionary}
            data={props.data}
            closePopupHandler={props.closePopupHandler}
            blockListBodyContentHandler={processContentBlockList}
          />
        );
      case "ficheInnovatieportfolio":
        setFicheTypeClassName("c-innovatieportfolio");
        props.data.detailImage &&
          setDetailImage(
            <Image
              src={props.data.detailImage.url}
              alt={props.data.detailImage.alt}
            />
          );

        return (
          <PopupInnovatieportfolio
            dictionary={props.dictionary}
            data={props.data}
            closePopupHandler={props.closePopupHandler}
            blockListBodyContentHandler={processContentBlockList}
          />
        );

      case "ficheWetenschappelijkOnderzoek":
        setFicheTypeClassName("c-ficheWetenschappelijkOnderzoek");
        props.data.detailImage &&
          setDetailImage(
            <Image
              src={props.data.detailImage.url}
              alt={props.data.detailImage.alt}
            />
          );

        return (
          <PopupWetenschappelijkOnderzoek
            dictionary={props.dictionary}
            data={props.data}
            closePopupHandler={props.closePopupHandler}
            blockListBodyContentHandler={processContentBlockList}
          />
        );

      case "ficheToolkit":
        setFicheTypeClassName("c-toolkit");
        return (
          <PopupToolkit
            dictionary={props.dictionary}
            data={props.data}
            blockListBodyContentHandler={processContentBlockList}
          />
        );
      default:
        break;
    }
  }, []);

  return (
    <div className={ficheTypeClassName}>
      <div
        className="c-dimmer"
        onClick={(evt) => {
          if (evt.target.classList.value.includes("c-dimmer")) {
            props.closePopupHandler();
          }
        }}
      >
        <div className="c-detail-fiche-wrap">
          <div className="c-detail-fiche">
            {ficheTypeClassName !== "c-publications" &&
            ficheTypeClassName !== "c-webinar" &&
            ficheTypeClassName !== "c-innovatieportfolio" &&
            ficheTypeClassName !== "c-ficheWetenschappelijkOnderzoek" ? (
              <>
                <header className="c-detail-fiche__header">
                  <div
                    className="popupClosingIconContainer"
                    onClick={() => props.closePopupHandler()}
                  >
                    <AiOutlineClose className="popupClosingIcon" />
                  </div>
                  <div className="image">{detailImage}</div>
                  <div
                    className="text"
                    style={
                      props.data.themeColor && {
                        backgroundColor: "#" + props.data.themeColor,
                      }
                    }
                  >
                    {props.data?.tagIcon?.url && (
                      <div className="c-tag-list">
                        <div className={`c-tag ${ficheTypeIconClass}`} title="">
                          <Image
                            src={props.data.tagIcon.url}
                            alt={props.data.tagIcon.alt}
                          />
                        </div>
                      </div>
                    )}
                    <div className="grid">
                      <div className="row">
                        <div className="col-12">
                          <h2
                            className="title"
                            dangerouslySetInnerHTML={{
                              __html: props.data.title,
                            }}
                          ></h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
                {content}
              </>
            ) : (
              content
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
